import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {Logger} from "dce-logger";
import {DceAjax} from "dce-ajax";
import {I18n} from "../../../dce-i18n/lib";
import HttpRoute from "../../../dce-ajax/lib/utils/HttpRoute";

interface SubSelectProps {
    value: string;
    triggerInput: string;
    containerSelector: string; //default 'form'
    url: string;
}

@Dce("SubSelect")
export default class SubSelect extends DceComponent<SubSelectProps> {

    private static _LOADER = '<div class="loader"><svg class="loader-svg" viewBox="-75 -75 150 150"><circle class="loader-svg-stroke" cx="0" cy="0" r="37.5"></circle></svg></div>';
    private static _SAVED = '<div class="savedicon"><svg viewBox="0 0 24 24"><path fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" /></svg></div>';

    private static _INDICATOR: string;

    private logger = Logger.of("SubSelect");

    private loadRoute: HttpRoute;

    private triggerInput: JQuery<HTMLElement>;

    private element: JQuery<HTMLElement>;

    private loadIndicator: JQuery<HTMLElement>;

    private triggerValue: string;

    constructor(elem: DceHTMLElement, props: SubSelectProps) {
        super(elem, props);
        this.logger.debug("Init SubSelect");

        SubSelect._INDICATOR = '<span class="change-save-indicator">'
            + '<span class="load">' + SubSelect._LOADER + I18n.getOrElse('loading', 'Pobieranie') + '</span>'
            + '<span class="save">' + SubSelect._SAVED + I18n.getOrElse('loaded', '') + '</span>'
            + '</span>';

        this.loadRoute = HttpRoute.of(this.props.url);

        this.element = $(elem);

        this.triggerInput = this.element.closest(this.props.containerSelector).find(
            this.props.triggerInput
        );

        this.logger.debug("TRIGGER INPUT", this.triggerInput)

        this.appendIndicator();

        this.triggerInput.on('change', e => {
            this.logger.debug("TRIGGER CHANGE");
            this.loadOptions(false);
        });

        this.loadOptions(true);
    }

    private appendIndicator(){
        var w = this.element.outerWidth();

        this.loadIndicator = $(SubSelect._INDICATOR);
        this.loadIndicator.css('margin-left', -1 * w);
        this.loadIndicator.css('width', (w - 1) + 'px');

        this.element.after(this.loadIndicator);
    }

    private indicateLoading(){
        this.loadIndicator.find('.load').addClass('loading');
    }

    private indicateStopLoading(){
        this.loadIndicator.find('.load').removeClass('loading');
        this.loadIndicator.find('.save').addClass('saved');

        setTimeout(() => {
            this.loadIndicator.find('.save').removeClass('saved');
        }, 400);
    }

    private loadOptions(init: boolean){

        let newval = this.triggerInput.val();

        if(null == newval){
            newval = "";
        }

        if(newval == this.triggerValue){
            return;
        }

        this.element.prop('disabled', true);

        this.triggerValue = newval.toString();

        this.element.empty();

        if(!this.triggerValue){
            this.element.val('');
        }else{

            this.indicateLoading();

            DceAjax.getInstance()
                .getWithCache(this.loadRoute.build(this.triggerValue))
                .then(res => {

                    let items = [];

                    if(res.hasData('options')){
                        items = res.getData('options') as any[];
                    }

                    if(items.length > 0) {

                        this.element.append("<option value=\"\"></option>");

                        this.element.append(
                            items.map(option => {
                                return '<option value="' + option[0] + '">' + option[1] + '</option>';
                            }).join("")
                        )

                        if (init) {
                            this.element.val(this._props.value);
                        }

                        this.element.prop('disabled', false);
                    }

                    this.indicateStopLoading();
                });
        }

    }



    defaultProps(): Partial<SubSelectProps> {
        return {
            value: "",
            triggerInput: "",
            containerSelector: "form",
            url: ""
        }
    }
}
